import { createSlice } from "@reduxjs/toolkit";

//* Define the options that createSlice will use
const sliceOptions = {
  name: "cards",
  initialState: {
    cards: {}
  },
  reducers: {
    addCard: (state, action) => {
      const { id, front, back } = action.payload;
      state.cards[id] = {
        id: id,
        front: front,
        back: back
      };
    }
  }
};

//* Create a new slice of state with the sliceOptions configuration object
export const cardsSlice = createSlice(sliceOptions);

//* Selectors
export const selectCard = (state) => state.cards.cards;

//* Export actions generated by createSlice()
export const { addCard } = cardsSlice.actions;

//* Export reducer generated by createSlice()
export default cardsSlice.reducer;
